module.exports = __webpack_public_path__ + "img/store_ytdx.549c3ede.jpeg";